// @flow

import { type IncomingPayment } from './types';

export function getCustomerName(incomingPayment: IncomingPayment): ?string {
  return incomingPayment['name'];
}

export function getSafeCustomerName(incomingPayment: IncomingPayment): string {
  const name = getCustomerName(incomingPayment);
  if (name == null)
    throw new Error('IncomingPayment - there is no customer name');
  return name;
}
